import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import Teams from '../TeamsEnum';
import CopaArgentinaTeams from '../CopaArgentinaTeams';

const Torneos = {
  LIGA_PROFESIONAL: "Liga Profesional Argentina",
  COPA_ARGENTINA: "Copa Argentina",
  COPA_SUDAMERICANA: "Copa Sudamericana",
  COPA_LIBERTADORES: "Copa Libertadores",
};

const Statuses = {
  PROGRAMADO: "Programado",
  FINALIZADO: "Finalizado",
  POSTERGADO: "Postergado",
  SUSPENDIDO: "Suspendido",
};

const Phases = {
  FASE_REGULAR: "Fase Regular",
  PLAYOFFS: "Playoffs",
};

const FixtureForm = ({ formData, onInputChange, onSubmit }) => {
  const [startDate, setStartDate] = useState(new Date());
  const teamsList = formData.torneo === "Copa Argentina" ? CopaArgentinaTeams : Teams;

  const handleDateChange = (date) => {
    setStartDate(date);
    const formattedDate = date.toLocaleDateString('en-GB');
    onInputChange({ target: { name: 'date', value: formattedDate } });
  };

  const isFormValid = () => {
    const required = ['torneo', 'jornada', 'vsTeam', 'date', 'matchHours', 'status'];
    return required.every((f) => formData[f] !== '' && formData[f] !== null && formData[f] !== undefined);
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-4 mb-3 mt-3">
          <label className="form-label">Torneo</label>
          <select
            className="form-control"
            name="torneo"
            value={formData.torneo}
            onChange={onInputChange}>
            <option value="" disabled>Seleccionar torneo</option>
            {Object.entries(Torneos).map(([k, v]) => (
              <option key={k} value={v}>{v}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 mb-3 mt-3">
          <label className="form-label">Jornada</label>
          <input
            type="number"
            className="form-control"
            name="jornada"
            min="1"
            value={formData.jornada}
            onChange={onInputChange}
            placeholder="Ej: 12"
          />
        </div>

        <div className="col-md-4 mb-3 mt-3">
          <label className="form-label">Versus</label>
          <select
            className="form-control"
            name="vsTeam"
            value={formData.vsTeam}
            onChange={onInputChange}>
            <option value="" disabled>Seleccionar equipo</option>
            {Object.entries(teamsList).map(([k, v]) => (
              <option key={k} value={v}>{v}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 mb-3 mt-3">
          <label className="form-label">Local / Visitante</label>
          <select
            className="form-control"
            name="isHome"
            value={formData.isHome}
            onChange={(e) => onInputChange({ target: { name: 'isHome', value: e.target.value === 'true' } })}>
            <option value="true">Local</option>
            <option value="false">Visitante</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3 mb-3">
          <label className="form-label">Fecha</label>
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            className="form-control"
            name="date"
            dateFormat="dd-MM-yyyy"
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Hora Partido</label>
          <input
            type="time"
            className="form-control"
            name="matchHours"
            value={formData.matchHours}
            onChange={onInputChange}
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Estadio (opcional)</label>
          <input
            type="text"
            className="form-control"
            name="venue"
            value={formData.venue}
            onChange={onInputChange}
            placeholder="Ej: Libertadores de América"
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label">Estado</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={onInputChange}>
            {Object.entries(Statuses).map(([k, v]) => (
              <option key={k} value={v}>{v}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3 mb-3">
          <label className="form-label">Resultado (opcional)</label>
          <input
            type="text"
            className="form-control"
            name="result"
            value={formData.result}
            onChange={onInputChange}
            placeholder="Ej: 2-1"
          />
          <small className="form-text text-muted">Solo completar si el partido ya se jugó</small>
        </div>

        {formData.torneo === Torneos.LIGA_PROFESIONAL && (
          <div className="col-md-3 mb-3">
            <label className="form-label">Fase</label>
            <select
              className="form-control"
              name="phase"
              value={formData.phase || ''}
              onChange={onInputChange}>
              <option value="">Sin fase</option>
              {Object.entries(Phases).map(([k, v]) => (
                <option key={k} value={v}>{v}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      <button
        type="submit"
        className="btn"
        style={{ backgroundColor: '#C73B33', borderColor: '#FF5733', color: '#FFF' }}
        disabled={!isFormValid()}>
        Agregar al Fixture
      </button>
    </form>
  );
};

export default FixtureForm;
